import { waitForElement } from "@/utils/waitForElementToLoad";
import { FC, useEffect } from "react";
import { usePathname } from 'next/navigation';

export const CookiebotDeclaration: FC = () => {

    const currentPath = usePathname();

    if (currentPath !== "/cookies") return null; // Skip below logic if page is not /cookies

    const replaceFormalPronouns = (container:HTMLElement) => {

        const replacements = [
            { regex: /\bUw\b/g, replacement: 'Jouw' },
            { regex: /\buw\b/g, replacement: 'jouw' },
            { regex: /\bU\b/g, replacement: 'Je' },
            { regex: /\bu\b/g, replacement: 'je' }
        ];
        const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
        let node: Node | null = walker.nextNode();
        while (node) {
            let orginalText = node.nodeValue;
            if (orginalText) {
                for (const { regex, replacement } of replacements) {
                    orginalText = orginalText.replace(regex, replacement);
                }
                node.nodeValue = orginalText;
            }
            node = walker.nextNode();
        }
    }

    useEffect(() => {
        const cookiebotId = process.env.NEXT_PUBLIC_COOKIEBOT_DOMAIN_GROUP_ID;
        if (!cookiebotId) return;

        const cd_container = document.getElementById('cookie-declaration-div');
        if (!cd_container) return;

        // Prevent duplicate script
        if (document.getElementById('CookieDeclaration')) return;

        if (cd_container) {
            const cd_script = document.createElement('script');
            cd_script.id = 'CookieDeclaration';
            cd_script.async = true;
            cd_script.src = `https://consent.cookiebot.com/${cookiebotId}/cd.js`;
            cd_container.appendChild(cd_script);
        }
    }, []);

    useEffect(() => {
        waitForElement('.CookieDeclaration', 4000, `#cookie-declaration-div`).then(() => {
            const container = document.querySelector<HTMLElement>('.CookieDeclaration');
            if (container) {
                replaceFormalPronouns(container);
            }
        }).catch((error) => console.debug(error.message));
    }, []);

    return null; // This component returns no UI component
}